import { action } from 'satcheljs';
import PublishingSettings from 'owa-service/lib/contract/PublishingSettings';

/**
 * Action to update the personal booking page publishing settings in the store.
 */
let updatePublishingSettings = action(
    'UPDATE_PBP_PUBLISHING_SETTINGS',
    (pbpPublishingSettings: PublishingSettings) => ({
        pbpPublishingSettings,
    })
);

export default updatePublishingSettings;
